require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-woerterberg.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-woerterberg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-woerterberg!./.cache/json/betreuungseinrichtungen-guessing-woerterberg.json
// module id = 908
// module chunks = 231608221292675